import React from 'react';
import { motion } from 'framer-motion';
import RelatedPostsSlider from '../components/RelatedPostsSlider';
import { Post, VideoData, VideoRefs } from '../types/socialGlass';
import { UI_CONSTANTS } from '../constants/uiConstants';

interface HottestPostsSectionProps {
  posts: Post[];
  idToData: Record<string, VideoData>;
  videoRefs: React.MutableRefObject<VideoRefs>;
  handleManualMute: () => void;
  handleManualUnmute: () => void;
}

const HottestPostsSection: React.FC<HottestPostsSectionProps> = ({
  posts,
  idToData,
  videoRefs,
  handleManualMute,
  handleManualUnmute,
}) => {
  const sliderData = posts.map((post) => ({
    postId: post.postId,
    postUsername: post.postUsername || post.user.name,
    postDesc: post.text || post.postDesc,
    postUrl: post.video,
    postLikes: post.postLikes,
    commentsCount: post.commentsCount,
    topComments: post.topComments || (post.comments || []).map((c) => ({
      username: c.user?.name,
      commentText: c.text,
      likes: c.likes,
    })),
  }));

  return (
    <div className="w-full">
      <div className="flex items-center gap-2">
        <h2 className="text-2xl font-bold">Hottest Posts</h2>
        <span className="mb-2 text-[16px] font-normal italic text-[#787878]">
          ({posts.length} featured posts)
        </span>
      </div>
      <div className="mt-2">
        <RelatedPostsSlider data={sliderData as any} />
      </div>
    </div>
  );
};

export default HottestPostsSection;
